export default ({ author }) => {
    return (
        <>
            {author.name}
        </>
    )
}
